/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, useRef, useState} from 'react'
import './header.scss'
import {useSelector} from 'react-redux'

////////////////////working///////////////////////
import {getAllUserDetails} from '../../../../app/pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {createFirstLetter} from '../../../../app/Utils/_helpers'

import {useOutsideAlerter} from '../../../../app/hooks/useOutsideAlerter'
import HeaderUserOnboarding from '../../../partials/layout/header-menus/HeaderUserOnboarding'

////////////////////try/////////////////
// import { QuickMsg } from 'app/Redux/AdminPanel/QuickMessageSlice'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px';

const TopbarOnboarding: FC = () => {
  const [isQuickActionOpen, setIsQuickActionOpen] = useState(false)

  const userValues = useSelector(getAllUserDetails)
  // const [socketID, setSocketID] = useState(io(ENDPOINT,{query:userId:"44444"}))

  const ref = useRef(null)
  useOutsideAlerter(ref, () => {
    setIsQuickActionOpen(false)
    if (isQuickActionOpen === true) {
    }
  })

  return (
    <>
      <div className='d-flex align-items-stretch flex-shrink-0'>
        {/* begin::User */}
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          {/* begin::Toggle */}
          <div
            className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            {userValues?.avatar === '' || userValues?.avatar === undefined || userValues?.avatar === 'undefined' ? (
              <span className='circle1'>{`${
                userValues?.firstName !== undefined && userValues?.firstName !== ''
                  ? userValues?.firstName?.split('')?.[0]?.toUpperCase() ?? 'C'
                  : createFirstLetter(userValues?.name)?.firstName ?? 'C'
              }${
                userValues?.lastName !== undefined && userValues?.lastName !== ''
                  ? userValues?.lastName?.split('')?.[0]?.toUpperCase() ?? 'C'
                  : createFirstLetter(userValues?.name).lastName ?? 'C'
              }`}</span>
            ) : (
              <img src={userValues?.avatar} alt='avatar' />
            )}
          </div>
          <HeaderUserOnboarding />
          {/* end::Toggle */}
        </div>
        {/* end::User */}
      </div>
    </>
  )
}

export {TopbarOnboarding}
